/*
 * vocal-activity.js — ГДЕ в записи поют. По отделённому вокальному стему.
 *
 * Зачем отдельный модуль. Forced alignment (ctc-forced-align.js) обязан уложить
 * текст во ВСЕ кадры записи, поэтому в проигрыше он находит что-нибудь похожее
 * на фонемы и размазывает по нему строки. Вызывающий, у которого есть стем
 * (/karaoke держит его всегда), может сказать выравнивателю, где голос есть, а
 * где его нет, — и это вся разница между «строка уехала на 16 с» и «строка на
 * месте». Замер 18.09.2026, 8 песен jamendolyrics с РУЧНОЙ разметкой строк,
 * вход «стем + 0.25 микса»: p90 ошибки строки 3.38 → 0.83 с, в секунду 90 → 92 %.
 *
 * Параметры ниже — те, на которых снят замер, а не подобранные на слух:
 *   порог  0.06 от 95-го перцентиля уровня САМОГО стема (−24 дБ): стем Kim
 *          Vocal 2 в паузах лежит на −45…−57 дБ, подпевка и дыхание — выше;
 *   поля   ±0.25 с вокруг каждого звучащего кадра: согласные на входе и
 *          затухание гласной тише порога, а слово начинается именно с них.
 * Уже и шире мерено (0.03/0.3 с, 0.1/0.2 с, 0.06/0.5 с) — хуже либо так же.
 *
 * ⚠️ Это НЕ детектор речи. Silero VAD для этого не годится: тянутую гласную он
 * речью не считает (замер 26.08, /lyrics-transcription), а петь — значит тянуть.
 *
 * ⚠️ Чего модуль НЕ умеет — и пусть никто не пробует снова, замерено дважды:
 * расставить СТРОКИ по фразам без распознавания. Раскладка «по длине строки на
 * звучащие участки стема» ставит в секунду 19 % строк, динамическое
 * программирование «строки ↔ фразы» — 19 % при медиане 13 с (хуже равномерной
 * раскладки: 10 с). Две фразы одной длины для энергии неразличимы.
 *
 *   VocalActivity.segments(channelData, sampleRate, opts) → {
 *       segments: [[startS, endS], …],   // где поют
 *       coverage: 0..1,                  // доля записи под голосом
 *       level:    number,                // 95-й перцентиль уровня стема
 *   }
 *
 * Чистая синхронная функция: 4 минуты стема — ~12 000 кадров, единицы мс.
 */
(function (root, factory) {
    var api = factory();
    if (typeof module === 'object' && module.exports) module.exports = api;
    if (root) root.VocalActivity = api;
})(typeof self !== 'undefined' ? self : (typeof window !== 'undefined' ? window : null), function () {
    'use strict';

    var ENV_HZ = 50;         // 20 мс — шаг кадра MMS; у GigaAM 40 мс, окна в секундах подходят обоим
    var THRESH_FRAC = 0.06;
    var PAD_S = 0.25;

    function envelope(ch, sr, hz) {
        var hop = sr / hz;
        var n = Math.max(1, Math.floor(ch.length / hop));
        var env = new Float32Array(n);
        for (var f = 0; f < n; f++) {
            var a = Math.floor(f * hop), b = Math.min(ch.length, Math.floor((f + 1) * hop)), s = 0;
            for (var i = a; i < b; i++) { var v = ch[i]; s += v * v; }
            env[f] = Math.sqrt(s / Math.max(1, b - a));
        }
        return env;
    }

    function percentile(env, p) {
        var a = Array.prototype.slice.call(env).sort(function (x, y) { return x - y; });
        return a.length ? a[Math.min(a.length - 1, Math.max(0, Math.round((a.length - 1) * p)))] : 0;
    }

    function segments(ch, sr, opts) {
        opts = opts || {};
        var hz = opts.hz || ENV_HZ;
        if (!ch || !ch.length || !(sr > 0)) return { segments: [], coverage: 0, level: 0 };
        var env = envelope(ch, sr, hz);
        var level = percentile(env, 0.95);
        var thr = level * (opts.threshFrac != null ? opts.threshFrac : THRESH_FRAC);
        var pad = Math.round((opts.padS != null ? opts.padS : PAD_S) * hz);
        var n = env.length, on = new Uint8Array(n), f;
        if (level > 0) {
            for (f = 0; f < n; f++) {
                if (env[f] > thr) {
                    var a = Math.max(0, f - pad), b = Math.min(n - 1, f + pad);
                    for (var k = a; k <= b; k++) on[k] = 1;
                }
            }
        }
        var segs = [], active = 0;
        f = 0;
        while (f < n) {
            if (!on[f]) { f++; continue; }
            var g = f; while (g < n && on[g]) g++;
            segs.push([f / hz, g / hz]);
            active += g - f;
            f = g;
        }
        return { segments: segs, coverage: n ? active / n : 0, level: level };
    }

    return { segments: segments, _envelope: envelope, ENV_HZ: ENV_HZ, THRESH_FRAC: THRESH_FRAC, PAD_S: PAD_S };
});
